module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/regenerator/index.js
// module id = 7
// module chunks = 14